module.exports = __webpack_public_path__ + "static/media/clear.777b93c6.svg";